import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { FormService } from '../../services/form.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-form-field-wrapper',
    templateUrl: './form-field-wrapper.component.html',
    styleUrls: ['./form-field-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldWrapperComponent implements OnInit {

  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;
  constructor(private formService: FormService) { }

  subsVar: Subscription;
  uomData : any;
  ngOnInit() {
    console.log(this.configData);
    console.log(this.frmGroup);

    this.frmGroup.get(this.configData.name)['componentType'] = this.configData.component;

    this.formService.fetchEvents.forEach(event=>{
      if(event && event.visibility){
          if(this.configData.controls[0].name == event.name){
            this.configData.controls.some(element => {
              event.eventList.forEach(e => {
                let elemName = element.name.toUpperCase();
                let eventName = e.toUpperCase();
                if(elemName === eventName) {
                  element.visibility = 'visible';
                  element.required = true;
                  element['checked'] = false;
                  event?.requiredList?.forEach(req => {
                    let reqVal = req.toUpperCase();
                    if(eventName === reqVal) {
                      element.required = false;
                    }
                  })
                  /* Affected colum's fields will be optional after changing dropdown (Ex: city to postalcode on rate-enquiryscreen)
                    "keepValue" flag will be true while triggering event from ngOnInit, will be false triggering from manageDropdown*/
                  let formField = this.frmGroup.get(this.configData.name)['controls'][0].get(element.name);
                  if(!event.keepValue){
                    formField.reset();
                  }
                  formField.setErrors({required:true});
                  formField.updateValueAndValidity();
                  return true;
                }
                else if(element['checked'] && element.visibility === 'visible'){
                  element.visibility = 'hidden';
                  element.required = false;

                  let formField = this.frmGroup.get(this.configData.name)['controls'][0].get(element.name);

                  formField.reset();
                  formField.setErrors(null);
                  formField.updateValueAndValidity();

                  return false;
                }
              }, this)
            }, this);
          }
      }
      this.configData.controls.map(elem=>{
        elem['checked'] = true;
      })
    })
    this.uomData = localStorage.getItem("preferredUOM");
  }

  getFormTableControls(){
    return this.frmGroup.controls[this.configData.name]['controls'];
  }

  getColumnsVisibility(control) {
    let cols = control.cols;
    let visibility = control.visibility;
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for ( let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }

    if(visibility === 'hidden'){
      colsClass += 'hidden';
    }

    return colsClass;
  }

}
